import metric from './metric';

export default metric;
